






































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListJiko from '@/components/common/search/ListJiko.vue';
import { API_SEARCH_JYKO } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlJiko',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListJiko,
  },
  props: {
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '加食事故',
    },
    widthCd: {
      type: Number,
      default: 81, //21,
    },
    widthName: {
      type: Number,
      default: 150,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_JYKO,
    listJikoShow: false,
    jikoCd: 0,
    jikoNaiyo: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { jikoCd, jikoNaiyo } = item;
      this.jikoCd = jikoCd;
      this.jikoNaiyo = jikoNaiyo;
      this.listJikoShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listJikoShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.jikoCd = value;
      if (value) {
        this.getJikoItem();
      } else {
        this.jikoNaiyo = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ jikoCd: this.jikoCd });
      }
    },
    getJikoItem() {
      axios
        .get(API_SEARCH_JYKO, {
          params: { jikoCd: this.jikoCd, mukoUmuFlg: this.mukoUmuFlg },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.jikoNaiyo = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk && this.callbackOk({ jikoCd: this.jikoCd });
            return;
          }
          this.errors = clearNoDataError();
          const { jikoNaiyo } = res.data.responseData[0];
          this.jikoNaiyo = jikoNaiyo;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [jikoCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.jikoCd': {
      handler(newValue) {
        if (+newValue === +this.jikoCd) return;
        this.jikoCd = +newValue;
        if (newValue) {
          this.getJikoItem();
        } else {
          this.jikoNaiyo = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.jikoCd) {
      this.jikoCd = +this.$attrs.jikoCd;
    }
  },
});
